// Feature toggles for the Organization details form, grouped for display.
// `name` must match the react-hook-form field / API payload key exactly.
// Add a new feature flag here — nowhere else.

export const ORGANIZATION_FEATURE_GROUPS = [
  {
    title: 'Labels & Printing',
    icon: 'fas fa-tags',
    items: [
      { name: 'myLabelsEnabled', label: 'My Labels' },
      { name: 'printArticleEnabled', label: 'Print Article' },
      { name: 'printOrderEnabled', label: 'Print Order' },
      { name: 'printLabelEnabled', label: 'Print Label' },
    ],
  },
  {
    title: 'Content Management',
    icon: 'fas fa-folder',
    items: [
      { name: 'myArticlesEnabled', label: 'My Articles' },
      { name: 'myOrdersEnabled', label: 'My Orders' },
    ],
  },
  {
    title: 'PDF Settings',
    icon: 'fas fa-file-pdf',
    items: [
      { name: 'pdfEnabled', label: 'PDF Enabled' },
      { name: 'pdfOnly', label: 'PDF Only' },
    ],
  },
  {
    title: 'Integration & Features',
    icon: 'fas fa-plug',
    items: [
      { name: 'integrationClientsEnabled', label: 'Integration Enabled' },
      { name: 'integrationWebHooksEnabled', label: 'Web Hooks Enabled' },
      { name: 'connectorsEnabled', label: 'Connectors Enabled' },
      { name: 'agentsEnabled', label: 'Agents Enabled' },
      { name: 'printHistoryEnabled', label: 'Print History Enabled' },
      { name: 'labelVersionControlEnabled', label: 'Quality Assurance Enabled' },
    ],
  },
  {
    title: 'Labels & Import',
    icon: 'fas fa-cogs',
    items: [
      { name: 'standardLabelsEnabled', label: 'Standard Labels Enabled' },
      { name: 'setupStandardLabelsEnabled', label: 'Setup Standard Labels' },
      { name: 'quickPrintEnabled', label: 'Quick Print Enabled' },
      { name: 'importEnabled', label: 'Import Enabled' },
      { name: 'globalCountersEnabled', label: 'Global counters enabled' },
      { name: 'sendToGroupEnabled', label: 'Send to group enabled' },
      { name: 'widgetsEnabled', label: 'Widgets Enabled' },
      { name: 'organizationSettingsEnabled', label: 'Organization Settings Enabled' },
    ],
  },
];

export const ORGANIZATION_FEATURE_NAMES = ORGANIZATION_FEATURE_GROUPS.flatMap(
  (group) => group.items.map((item) => item.name)
);
